(function () {
	'use strict';

	angular.module('resetPasswordModule', ['ui.bootstrap', 'pascalprecht.translate', 'angularutilities'])
		.controller('resetPasswordCtrl', ResetPasswordCtrl);

	function ResetPasswordCtrl($scope, $timeout, $http, $location, $uibPosition, $sce) {
		// Load globalConfig to check for username or parts of username in password
		$http.get('/api/2/UserConfig')
			.then(function(response) { 
				window.globalConfig = response.data;
			});
		$scope.showExtraStrengthInfo = false;
		$scope.passwordProblemType = undefined;
		$scope.passwordTooShort = true;
		$scope.newPassword = '';
		$scope.confirmNewPassword = '';
		$scope.passwordFieldTypes = {
			new: 'password',
			confirm: 'password'
		};

		// from password_utils.js
		var passwordUtils = new PasswordUtils();
		$scope.$watch('newPassword', function() {
			passwordUtils.checkStrength($scope, $sce);
		});
		var checkRequirements = passwordUtils.checkRequirements.bind(null, $scope);
		checkRequirements();
		$scope.$watch('confirmNewPassword', checkRequirements);

		$scope.submit = submit;
		$scope.toggleFieldType = toggleFieldType;

		$scope.clearToast = function() {
			$scope.toastMessage = undefined;
			$scope.errorToast = false;
		};

		function processResponse (response) {
			if (response.data.message === 'Password Changed') {
				$scope.toastMessage = response.data.message;
				$scope.username = response.data.username;
				setTimeout(function() {
					sendToRedirect(response.data.redirectUrl);
				}, 2000);
			} else if (response.status === 401) {
				$scope.toastMessage = 'Unauthorized - Make sure you have cookies enabled';
				$scope.errorToast = true;
			} else if (response.status === 400 && response.data && response.data.message) {
				$scope.toastMessage = response.data.message;
				$scope.errorToast = true;
			}
			$timeout(function() {
				$scope.clearToast();
			}, 3000);
		}

		function toggleFieldType(field) {
			var newValue = $scope.passwordFieldTypes[field] === 'password' ? 'text' : 'password';
			$scope.passwordFieldTypes[field] = newValue;
		}
	
		function submit() {
			passwordUtils.checkStrength($scope, $sce);
			checkRequirements();
			if (!$scope.usernameLoaded) {
				$scope.toastMessage = 'Error loading user profile';
				$scope.errorToast = true;
				return;
			}
			$http.post(
				'/api/2/SetPassword',
				{
					'newPassword': encodeURIComponent($scope.newPassword)
				}, 
				{
					headers: {'XSRF-TOKEN': 'LDNA'}
				})
				.then(processResponse)
				.catch(processResponse);
		}

		function sendToRedirect(redirectUrl) {
			window.location.href = redirectUrl;
		}
	}
})();
